import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { updateField } from '../../../services';
import styles from './../../styles.module.scss';

const EditExperience = ({ userID, years, setStep, setAction }) => {
  const [decimal, setDecimal] = useState(null);

  const textWithExperience = `
    How many years have you worked in global development?
  `;
  const textWithoutExperience = `
    Recruiters are 6 times more likely to view profiles that include experience level.
    How many years of experience do you have in development?
  `;

  const handleSubmitExperience = (experience) => {
    const data = {
      consultant: {
        experience_duration: parseInt(experience),
      },
    };
    updateField('experience_duration', data, userID);
    setAction('updating');
    setStep('done');
  };

  const displayExperienceRange = () => {
    const decimalButtons = ['0 - 9', '10 - 19', '20 - 29', '30 - 39', '40 - 49', '50 - 59'];
    return decimalButtons.map((decimalButton, index) => {
      return (
        <li key={decimalButton} className='ps-15 pe-15'>
          <button
            type='button'
            className={`btn mt-15 mb-15 btn-outline-info btn-lg ${styles.yoeBtn}`}
            onClick={() => {
              setDecimal(index);
            }}
          >
            {decimalButton}
          </button>
        </li>
      );
    });
  };

  const displayExperienceOptions = () => {
    const digitButtons = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    return digitButtons.map((digitButton) => {
      const experience = decimal > 0 ? `${decimal}${digitButton}` : digitButton;
      return (
        <li key={digitButton} className='ps-15 pe-15'>
          <button
            type='button'
            className={`btn mt-15 mb-15 btn-outline-info btn-lg ${styles.yoeBtn}`}
            onClick={() => handleSubmitExperience(experience)}
          >
            {experience}
          </button>
        </li>
      );
    });
  };

  return (
    <div className={`${styles.dataInput} ${styles.yoe}`} data-testid='edit-experience'>
      <label className='mb-15'>
        <span className={years ? styles.question : styles.pitch}>
          {years ? textWithExperience : textWithoutExperience}
        </span>
      </label>
      <ul className={`${styles.yoeButtonGroup} mt-25 list-inline`}>
        {decimal === null ? displayExperienceRange() : displayExperienceOptions()}
      </ul>
    </div>
  );
};

EditExperience.propTypes = {
  userID: PropTypes.number,
  years: PropTypes.number,
  setStep: PropTypes.func,
  setAction: PropTypes.func,
};

export default EditExperience;
